import { useState } from 'react';
import { CampaignBannerConfig } from '@/lib/themeConfig';
import { SaveButton } from './GeneralSection';
import ImageUploader from '../ImageUploader';

interface Props { data: CampaignBannerConfig; onChange: (data: CampaignBannerConfig) => void; }

type BannerKey = 'main' | 'gift' | 'coldbrew';
const BANNERS: { key: BannerKey; label: string }[] = [
  { key: 'main', label: 'Ana Banner (Sol)' },
  { key: 'gift', label: 'Hediye Banner' },
  { key: 'coldbrew', label: 'Cold Brew Banner' },
];

export default function CampaignSection({ data, onChange }: Props) {
  const [local, setLocal] = useState<CampaignBannerConfig>(data);
  const [active, setActive] = useState<BannerKey>('main');
  const [saved, setSaved] = useState(false);

  const u = (key: string, val: string) => setLocal(p => ({ ...p, [active]: { ...p[active], [key]: val } }));
  const handleSave = () => { onChange(local); setSaved(true); setTimeout(() => setSaved(false), 2000); };
  const b = local[active];

  return (
    <div className="max-w-2xl space-y-6">
      <div className="bg-white rounded-2xl p-4 flex gap-2">
        {BANNERS.map(bn => (
          <button key={bn.key} onClick={() => setActive(bn.key)} className={`px-4 py-2 rounded-xl text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${active === bn.key ? 'bg-amber-600 text-white' : 'bg-stone-100 text-stone-600 hover:bg-stone-200'}`}>{bn.label}</button>
        ))}
      </div>
      <div className="bg-white rounded-2xl p-6 space-y-4">
        <div><label className="block text-xs font-medium text-stone-600 mb-1.5">Rozet</label><input type="text" value={b.badge} onChange={e => u('badge', e.target.value)} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" /></div>
        <div><label className="block text-xs font-medium text-stone-600 mb-1.5">Başlık</label><textarea value={b.title} onChange={e => u('title', e.target.value)} rows={2} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all resize-none" /></div>
        <div><label className="block text-xs font-medium text-stone-600 mb-1.5">Açıklama</label><input type="text" value={b.description} onChange={e => u('description', e.target.value)} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" /></div>
        <div className="grid grid-cols-2 gap-4">
          <div><label className="block text-xs font-medium text-stone-600 mb-1.5">Buton Metni</label><input type="text" value={b.cta_text} onChange={e => u('cta_text', e.target.value)} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" /></div>
          <div><label className="block text-xs font-medium text-stone-600 mb-1.5">Buton Linki</label><input type="text" value={b.cta_link} onChange={e => u('cta_link', e.target.value)} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" /></div>
        </div>
        <ImageUploader
          label="Banner Görseli"
          value={b.image_url}
          onChange={val => u('image_url', val)}
          previewHeight="h-32"
        />
      </div>
      <SaveButton saved={saved} onSave={handleSave} />
    </div>
  );
}
